import useSWR from 'swr'

import { RewardsAerodromeResponse } from '../constants/rewards'
import useAuth from './useAuth'

const fetcher = async (): Promise<RewardsAerodromeResponse> => {
  const res = await fetch('/api/rewards/aero')
  return await res.json()
}

export default function useAerodromeRewards() {
  const { user } = useAuth()
  return useSWR(['AerodromeRewards', user?.address], fetcher)
}
